import { createRef } from "react";
import { TableUserFilter } from "../TableUserFilter";
import { SearchFilterButton } from "./SearchFilterButton";

export const GetUserFilterProps = ({
  setQueryParamFunction,
  queryParamValue,
  queryParamKey,
}) => {
  const inputRef = createRef();

  return {
    filterDropdown: ({ confirm }) => (
      <TableUserFilter
        inputRef={inputRef}
        onReset={() => setQueryParamFunction(queryParamKey, undefined)}
        onSubmit={(value) => setQueryParamFunction(queryParamKey, value)}
        confirm={confirm}
        queryParamValue={queryParamValue}
      />
    ),
    filterIcon: () => (
      <SearchFilterButton
        isActive={!!queryParamValue}
        data-test-id="user-search-filter-button"
        isUserFilter={true}
      />
    ),
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => inputRef.current?.focus(), 100);
        }
      },
    },
  };
};
